import script from "./timeboardnew.vue?vue&type=script&setup=true&lang=js"
export * from "./timeboardnew.vue?vue&type=script&setup=true&lang=js"

import "./timeboardnew.vue?vue&type=style&index=0&id=57dc41bc&lang=less&scoped=true"

import exportComponent from "E:\\zhengbo-supplychain\\web-supplychain\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57dc41bc"]])

export default __exports__